import { render, staticRenderFns } from "./SwitchAudioRoute.vue?vue&type=template&id=450e7dac&scoped=true"
import script from "./SwitchAudioRoute.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchAudioRoute.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SwitchAudioRoute.vue?vue&type=style&index=0&id=450e7dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e7dac",
  null
  
)

export default component.exports